<ds-item-search-result-grid-element [showLabel]="showLabel" [object]="{ indexableObject: object, hitHighlights: {} }" [linkType]="linkType">
    <ng-content></ng-content>
    <ng-content></ng-content>
</ds-item-search-result-grid-element>
